import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import Container from "react-bootstrap/Container";
import { FaNode, FaReact } from "react-icons/fa";
import { TbBrandThreejs } from "react-icons/tb";
import { NavLink } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import tagdx from "../../assets/images/tag-dx.png";
import tagsx from "../../assets/images/tag-sx.png";
import { Context } from "../../context";
import Spacer from "../Utils/Spacer";
import classes from "./About.module.css";

const TopHome = () => {
  const { debug, lang } = useContext(Context);

  if (debug) {
    console.log("render About");
  }

  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  return (
    <section id="topHome" className={classes.boxTop + " section p_zero"}>
      <div className="p_zero container text-center m-auto justify-content-center">
        <div className="row">
          <Spacer height="80" mobile={true}></Spacer>

          <VisibilitySensor
            onChange={changeVisibility}
            partialVisibility
            delayedCall
          >
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{
                opacity: isVisible ? 1 : 0,
                y: isVisible ? 0 : 20,
              }}
              transition={{ duration: 0.4, delay: 0.5 }}
              className={`${classes.topHome1} p-3 col-md-6`}
            >
              <div className={classes.boxHome2}>
                <div className={classes.boxHome2Int}>
                  <p
                    className={
                      classes.boxHome3Text1 + " text-9 mb-1  text-white"
                    }
                  >
                    {lang === "en" && <>This site</>}
                    {lang === "it" && <>Questo sito</>}
                  </p>
                  <p className="text-4 mb-1 text-white">
                    {lang === "en" && (
                      <>
                        personal site developed in
                        <br />
                        <FaReact size={33} /> and <FaNode size={48} />
                        <br />
                        in this site you will find my skills
                        <br />
                        and demos of possible realizations
                      </>
                    )}
                    {lang === "it" && (
                      <>
                        {" "}
                        sito personale sviluppato in <br />
                        <FaReact size={32} /> and <FaNode size={44} />
                        <br />
                        in questo sito troverai le mie skills e demo di
                        possibili realizzazioni
                      </>
                    )}
                  </p>
                </div>
              </div>
            </motion.div>
          </VisibilitySensor>

          <VisibilitySensor
            onChange={changeVisibility}
            partialVisibility
            delayedCall
          >
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{
                opacity: isVisible ? 1 : 0,
                y: isVisible ? 0 : 20,
              }}
              transition={{ duration: 0.4, delay: 0.2 }}
              className={`${classes.topHome2} p-3 col-md-6`}
            >
              <div className={classes["boxHome1-arrow"]}></div>
              <div className={classes.boxHome1}>
                <h2 className={`${classes.boxHome3Text3} text-4 mb-0 mt-2`}>
                  <p className="text-9 bold">3d Room</p>
                  {lang === "en" && (
                    <>
                      3d real time animation of a work room,
                      <br />
                      developed in three.js
                    </>
                  )}
                  {lang === "it" && (
                    <>
                      Animazione 3d in tempo reale di una
                      <br />
                      stanza di lavoro, sviluppata in three.js
                    </>
                  )}

                  <TbBrandThreejs size="34" style={{ marginLeft: "5px" }} />
                </h2>
                <Container>
                  <a
                    href="https://workroom.davidebalice.dev/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-0 text-3 btn-hover">
                      {lang === "en" && <>Visit room</>}
                      {lang === "it" && <>Visualizza la stanza</>}
                    </span>
                  </a>
                </Container>
              </div>
            </motion.div>
          </VisibilitySensor>

          <Spacer height="30"></Spacer>

          <VisibilitySensor
            onChange={changeVisibility}
            partialVisibility
            delayedCall
          >
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{
                opacity: isVisible ? 1 : 0,
                y: isVisible ? 0 : 20,
              }}
              transition={{ duration: 0.4, delay: 0.8 }}
              className={`${classes.topHome3} p-3 col-md-12`}
            >
              <div className={classes.boxHome3}>
                <div className={classes["boxHome3-icon"]}>
                  <img src={tagsx} alt="tagsx" />
                </div>
                <div>
                  <p className={classes.boxHome3Text1 + " text-9 mb-0 mt-5"}>
                    {lang === "en" && <>Ready for next</>}
                    {lang === "it" && <>Pronto per la prossima</>}
                  </p>
                  <p className={classes.boxHome3Text1 + " text-10 mb-1"}>
                    {lang === "en" && <>adventure</>}
                    {lang === "it" && <>avventura</>}
                  </p>
                  <p className={classes.boxHome3Text2 + " text-4 mb-3"}>
                    {lang === "en" && (
                      <>
                        Ready for hiring or collaboration
                        <br />
                        in full remote, contact me
                      </>
                    )}
                    {lang === "it" && (
                      <>
                        Pronto per assunzione o collaborazione
                        <br />
                        in full remote, contattami
                      </>
                    )}
                  </p>
                  <NavLink to="/contact" className="nav-link smooth-scroll">
                    <span className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2 text-3">
                      <i
                        className="fa fa-envelope"
                        style={{
                          verticalAlign: "baseline",
                          fontWeight: "bold",
                        }}
                      ></i>{" "}
                      {lang === "en" && <>Contact me</>}
                      {lang === "it" && <>Contattami</>}
                    </span>
                  </NavLink>
                </div>
                <div className={classes["boxHome3-icon"]}>
                  <img src={tagdx} alt="tagdx" />
                </div>
              </div>
            </motion.div>
          </VisibilitySensor>

          <Spacer height="80"></Spacer>
        </div>
      </div>
    </section>
  );
};

export default TopHome;
